import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { AngularFireDatabase } from '@angular/fire/database';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoadingController, Platform } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
//import { SQLitePorter } from '@ionic-native/sqlite-porter/ngx';
import { SQLiteObject, SQLite } from '@ionic-native/sqlite/ngx';
import { timingSafeEqual } from 'crypto';

const FILENAME_DB = 'asap.db'
@Injectable({
  providedIn: 'root'
})
export class SqlitebaseService {
  

  private lstNotifications = new BehaviorSubject([]);
  nbrTotNotifications = new BehaviorSubject(0);
  //private sqlitePorter: SQLitePorter
  private database: SQLiteObject
  private dbReady: BehaviorSubject<boolean> = new BehaviorSubject(false)

  loading: HTMLIonLoadingElement

  constructor(private db: AngularFireDatabase, private loadingController: LoadingController, private http: HttpClient, private sqlite: SQLite) {

  }
  // private deleteTable() {
  //   this.database.executeSql('DROP TABLE IF EXISTS Notifytbl').then
  //     (_ => {
  //       console.log("delete tbl")
  //       this.creatTable()
  //     }).finally(
  //       () => this.creatTable()
  //     )
  // }
  createDB() {
    this.sqlite.create({
      name: FILENAME_DB,
      location: 'default'
    }).then((db: SQLiteObject) => {
      this.database = db;
     this.creatTablegestQuittanceExpitbl();
     this.creatTableNotifytbl();
    })
  }

 

  private creatTablegestQuittanceExpitbl() {
    this.http.get('assets/QuittanceScript.sql', { responseType: 'text' })
      .subscribe(sql => {   
        
        
       this.database.executeSql(sql,[])
          .then(_ => {  
           // console.log(sql);
              
            this.loadNotifyAutomatique();
            this.dbReady.next(true);
            
          })
          .catch(e => console.log(e));
      });
    }
    
  private creatTableNotifytbl() {
    this.http.get('assets/NotifyScript.sql', { responseType: 'text' })
      .subscribe(sql => {
       
       this.database.executeSql(sql,[])
          .then(_ => { 
           // console.log(sql);
        
            this.loadNotify();
            this.dbReady.next(true);
          })
          .catch(e => console.log(e));
      });



  }

  getDatabaseState() {
    return this.dbReady.asObservable();
  }
  getNotifications() {
    return this.lstNotifications.asObservable()
  }
  getTotalNotifications() {
    return this.nbrTotNotifications.asObservable()
  }

  // Add
  addNotifications(Type_Not, libelle_Not, date_Not, j, m, a, h, mm, s, ic, lu = false, Reference_Not = "") {
    let data = [Type_Not, libelle_Not, Reference_Not, date_Not, j, m, a, h, mm, s, lu, ic] // [name, JSON.stringify(skills), img];

    return this.database.executeSql('INSERT INTO Notifytbl (TypeNotify, TextNotify, RefNotify,dateNotify,j,m,a,h,mm,s,lu,ic) VALUES (?, ?, ?,?, ?, ?,?, ?, ?,?,?,?)', data)
      .then(data => {
        this.loadNotify();
      });
  }
  // Update
  updateNotifications(id) {
    let data = ['true'];
    return this.database.executeSql(`UPDATE Notifytbl SET lu = ? WHERE IdNotify = ${id}`, data)
      .then(data => {
        //this.loadNotify();
      })
  }

 private async loadNotify() {

    return this.database.executeSql('select * from Notifytbl order by TypeNotify,IdNotify desc', []).then(data => {
      let notifytbl = []
      let tab1 = []
      //this.loading.dismiss()
      if (data.rows.length > 0) {

        for (var i = 0; i < data.rows.length; i++) {
          notifytbl.push({
            Id: data.rows.item(i).IdNotify,
            Type_Not: data.rows.item(i).TypeNotify,
            libelle_Not: data.rows.item(i).TextNotify,
            Reference_Not: data.rows.item(i).RefNotify,
            date_Not: data.rows.item(i).dateNotify,
            j: data.rows.item(i).j.split('.')[0],
            m: data.rows.item(i).m,
            a: data.rows.item(i).a,
            h: data.rows.item(i).h.split('.')[0],
            mm: data.rows.item(i).mm.split('.')[0],
            s: data.rows.item(i).s.split('.')[0],
            lu: data.rows.item(i).lu,
            icon: data.rows.item(i).ic,
          });
        }
        //console.log("affichage", notifytbl)
        
        const map = new Map();
        if (notifytbl.length > 0) {
          for (const item of notifytbl) {
            if (!map.has(item.Type_Not)) {
              map.set(item.Type_Not, true);
              tab1.push({
                Type_Not: item.Type_Not.toUpperCase(),
                icon: item.icon,
                nbrNonlu: notifytbl.filter(a => a.lu == 'false' && a.Type_Not == item.Type_Not).length,
                data: notifytbl.filter(a => a.Type_Not == item.Type_Not).sort((a, b) => (a.Id < b.Id) ? 1 : -1) //tris du plus grand id au plus petit
              })
            }
          }
        }

      }

      this.lstNotifications.next(tab1);
      let r = 0
      tab1.map((a) => { r += a.nbrNonlu })
      this.nbrTotNotifications.next(r)
      //this.loading.dismiss()
    }).catch(
      error => {
            console.error(error);
      }).finally(
        //() => this.loading.dismiss()
      )

    // return this.lstNotifications.asObservable();
  }
  async loadNotifyAutomatique() {
   // this.lstNotifyAutomatique.next(null);
   //select * from gestQuittanceExpitbl where  order by IdNotify desc
   return  this.database.executeSql("select * from gestQuittanceExpitbl where Etat='1' and Stop='0' order by IdNotify desc", [])

    // return this.lstNotifications.asObservable();
  }
  // Add
  addDataNotifyAutomation(IDquit:string, NumPolice, DateEffet, DateExpirat, DateInsert, Etat, Stop) {
   return this.database.executeSql("select * from gestQuittanceExpitbl WHERE IDquit = '" + IDquit +"'", [])
      .then(data => {
        if (data.rows.length == 0) {
          let data = [IDquit, NumPolice, DateEffet, DateExpirat, DateInsert, Etat, Stop] // [name, JSON.stringify(skills), img];
         return this.database.executeSql('INSERT INTO gestQuittanceExpitbl (IDquit, NumPolice, DateEffet,DateExpirat,DateInsert,Etat,Stop) VALUES (?, ?, ?,?, ?, ?,?)', data)
            .then(data => {
              this.loadNotifyAutomatique();
            });
        }
      })


  }
  // Update
  updateNotifyAutomation($key, etat, stop) {
    let data = [etat, stop];
    return this.database.executeSql(`UPDATE gestQuittanceExpitbl SET Etat = ?,Stop= ? WHERE IDquit ='${$key}'`, data)
     
  }

}

